import log from 'salvo-lite/log'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default'

class Photoswipe {
    constructor (theme, elem) {
        this._elem = elem
        this._popup = document.querySelector('[data-photoswipe-popup]')
        this._items = this._elem.querySelectorAll('[data-photoswipe-item]')
        this._photoswipe = null
        this._options = Object.assign({
            showAbove: null,
            showBelow: null
        }, JSON.parse(this._elem.dataset.photoswipe ? this._elem.dataset.photoswipe : '{}'))

        if (this._options.mobileOnly) {
            this._options.showBelow = 769
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        if (this._options.showAbove && window.innerWidth <= this._options.showAbove) {
            return false
        }

        if (this._options.showBelow && window.innerWidth >= this._options.showBelow) {
            return false
        }
        let items = []
        for (let item of this._items) {
            items.push(JSON.parse(item.dataset.photoswipeItem))
        }
        log.debug(this.constructor.name, 'Initiating', this)

        for (let [index, slide] of this._items.entries()) {
            slide.addEventListener('click', e => {
                e.preventDefault()
                this._photoswipe = new PhotoSwipe(this._popup, PhotoSwipeUIDefault, items, {
                    index: index,
                    showHideOpacity: true,
                    getThumbBoundsFn: () => {
                        let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
                        let rect = slide.getBoundingClientRect()
                        return {
                            x: rect.left,
                            y: rect.top + pageYScroll,
                            w: rect.width
                        }
                    },
                    zoomEl: true,
                    maxSpreadZoom: 2,
                    getDoubleTapZoom: (isMouseClick, item) => {
                        return item.initialZoomLevel
                    },
                    pinchToClose: false
                })
                this._photoswipe.listen('beforeChange', (index, what) => {
                    let nextSlide = this._photoswipe.getCurrentIndex()
                    if (this._elem.hasAttribute('data-slider')) {
                        this._elem.dispatchEvent(new CustomEvent('changeSlide', { detail: nextSlide }))
                    }
                })
                this._photoswipe.init()
            })
        }
        log.debug(this.constructor.name, 'Initiated', this)
    }
}

export default Photoswipe



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Photoswipe.js